import React from 'react';
import { ServerService } from './../../../services/server.service';
import $ from 'jquery';

class Activity extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activityFeeds: [],
            isdatapresent: false,
            dateToggle: false,
            eventToggle: false,
            columnName: 'event'
        };
    }
    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.getActivityList();
    }

    getActivityList() {
        this.props.bgShadowHandler(true);
        ServerService.getActivities(this.props.computeRegionUrl, this.props.instanceId).then(resp => {
            this.props.bgShadowHandler(false);
            if(!resp) {
                return;
            }
            let dataFilter = [];
            for(let i = 0; i < resp.length; i++) {
                if(resp[i].action != "live-migration") {
                    let obj = {
                        "action": resp[i].action,
                        "start_time": resp[i].start_time
                    };
                    dataFilter.push(obj);
                }
            }
            this.setState({ activityFeeds: this.getSortable('date', dataFilter) });
        });
    }

    setSortable(type) {
        this.setState({ backupList: this.getSortable(type, this.state.activityFeeds) });
    }

    getSortable = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnName: type });
        if(type === "event") {
            if(this.state.eventToggle) {
                items.sort(function (a, b) {
                    if(a.action < b.action) { return -1; }
                    if(a.action > b.action) { return 1; }
                    return 0;
                });
            } else {
                items.sort(function (a, b) {
                    if(a.action < b.action) { return 1; }
                    if(a.action > b.action) { return -1; }
                    return 0;
                });
            }
            this.setState({ eventToggle: !this.state.eventToggle });
            return items;
        } else if(type === "date") {
            if(this.state.dateToggle) {
                items.sort(function (a, b) {
                    return new Date(a.start_time) - new Date(b.start_time);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.start_time) - new Date(a.start_time);
                });
            }
            this.setState({ dateToggle: !this.state.dateToggle });
            return items;
        }
    };

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };

    render() {
        return (
            <section className={ this.state.isdatapresent ? "settingModule_wrapper" : "settingModule_wrapper activity_setting_module" }>
                { this.state.isdatapresent ? <div>
                    <div class="outer_empty_wrap">
                        <div class="inner_empty_wrap">
                            <div class="svg_wrap empty_icon activity_empty"></div>
                            <p class="empty_title">No Activities</p>
                        </div>
                    </div>
                </div> : <div>

                    <div className="settModule_head_wrap">
                        <div className="settModule_head_lhs">
                            <h2>Activity Feed</h2>
                            <p>View action/event log for the instance</p>
                        </div>
                        <div className="settModule_head_rhs">
                            {/* <div className="cta_wrap">
                            <div className="pdf_download">
                                <span className="svg_wrap">
                                    <svg
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 512 512"
                                        enableBackground="new 0 0 512 512"
                                        xmlSpace="preserve">
                                        <g>
                                            <g>
                                                <g>
                                                    <path
                                                        fill="#F24C4C"
                                                        d="M393.7,149.4l-77.8-77.8c-1.5-1.5-3.4-2.3-5.5-2.3H147.1c-17.2,0-31.1,14-31.1,31.1v311.1     c0,17.2,14,31.1,31.1,31.1h217.8c17.2,0,31.1-14,31.1-31.1V154.9C396,152.8,395.2,150.8,393.7,149.4z M318.2,95.9l51.2,51.2     h-35.7c-8.6,0-15.6-7-15.6-15.6V95.9z M380.4,411.6c0,8.6-7,15.6-15.6,15.6H147.1c-8.6,0-15.6-7-15.6-15.6V100.4     c0-8.6,7-15.6,15.6-15.6h155.6v46.7c0,17.2,14,31.1,31.1,31.1h46.7V411.6z"></path>
                                                    <path
                                                        fill="#F24C4C"
                                                        d="M295.7,297.7c-7.2-5.7-14-11.5-18.6-16c-5.9-5.9-11.2-11.7-15.8-17.1c7.2-22.1,10.3-33.5,10.3-39.6     c0-25.8-9.3-31.1-23.3-31.1c-10.6,0-23.3,5.5-23.3,31.9c0,11.6,6.4,25.7,19,42.1c-3.1,9.4-6.7,20.3-10.8,32.5     c-2,5.9-4.1,11.3-6.3,16.3c-1.8,0.8-3.6,1.6-5.3,2.5c-6.2,3.1-12.1,5.9-17.5,8.5c-24.8,11.8-41.2,19.5-41.2,34.9     c0,11.2,12.1,18.1,23.3,18.1c14.5,0,36.3-19.3,52.2-51.9c16.6-6.5,37.1-11.4,53.4-14.4c13,10,27.4,19.6,34.4,19.6     c19.3,0,23.3-11.2,23.3-20.5c0-18.4-21-18.4-31.1-18.4C315.1,294.9,306.7,295.8,295.7,297.7z M186,364.9c-4.4,0-7.5-2.1-7.8-2.5     c0-5.5,16.4-13.3,32.3-20.8c1-0.5,2-1,3.1-1.5C202,357,190.4,364.9,186,364.9z M240.4,225.6c0-16.3,5.1-16.3,7.8-16.3     c5.5,0,7.8,0,7.8,15.6c0,3.3-2.2,11.5-6.2,24.3C243.7,239.8,240.4,231.7,240.4,225.6z M246.4,309.2c0.5-1.4,1-2.7,1.4-4.1     c2.9-8.7,5.5-16.4,7.8-23.4c3.2,3.6,6.7,7.2,10.4,10.9c1.5,1.5,5.1,4.7,9.9,8.8C266.4,303.5,256.2,306.1,246.4,309.2z      M333.8,313.3c0,3.5,0,4.9-7.2,5c-2.1-0.5-7-3.3-13.1-7.5c2.2-0.2,3.8-0.4,4.7-0.4C329.7,310.4,333,311.6,333.8,313.3z"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </span>Download PDF</div>
                            <div className="send_email">
                                <span className="svg_wrap">
                                    <svg
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 512 512"
                                        enableBackground="new 0 0 512 512"
                                        xmlSpace="preserve">
                                        <g>
                                            <g>
                                                <path
                                                    fill="#378EC3"
                                                    d="M432.4,109.4H79.6C58.9,109.4,42,126.3,42,147v218c0,20.7,16.9,37.6,37.6,37.6h352.8    c20.7,0,37.6-16.9,37.6-37.6V147C470,126.3,453.1,109.4,432.4,109.4z M427.5,134.5l-5,4.2L270.9,264.8c-8.6,7.2-21.2,7.2-29.8,0    L89.5,138.6l-5-4.2H427.5z M67.1,152.6l123.5,102.8L67.1,337.5V152.6z M432.4,377.5H79.6c-6.1,0-11.1-4.3-12.3-10l143.3-95.4    l14.4,12c9,7.5,20,11.2,31,11.2c11,0,22-3.7,31-11.2l14.4-12l143.3,95.4C443.5,373.2,438.4,377.5,432.4,377.5z M444.9,337.5    l-123.5-82.2l123.5-102.8V337.5z"></path>
                                            </g>
                                        </g>
                                    </svg>
                                </span>Send an email</div>
                        </div>
                     */}
                        </div>
                    </div>
                    <div className="activityModule_wrap clearfix">
                        <div className="activity_table_wrap">
                            <div className="tabular_data_wrap">
                                <div className="table_header">
                                    <ul>
                                        <li className="th">
                                            <div className="col col1">
                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("event"); } }>Event<span className="sort_icon"></span>
                                                </div>
                                            </div>

                                            <div className="col col2">
                                                <div className="header_sort_wrap" onClick={ (event) => { this.headerSortClick(event); this.setSortable("date"); } }>When<span className="sort_icon active"></span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="table_data">
                                    <ul>{ this.state.activityFeeds.length === 0 ?
                                        <div className="inner_empty_wrap">
                                            <div className={ "svg_wrap empty_icon summary_empty activity_empty" }></div>
                                            <p className="empty_title">No Activities</p>
                                        </div> : this.state.activityFeeds.map((activityFeed, i) => (
                                            <li className="tr" key={ i }>
                                                <div className="col col1">{ activityFeed.action }</div>
                                                <div className="col col2">{ activityFeed.start_time }</div>
                                            </li>
                                        ))
                                    }

                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </section>
        );
    }
}

export default Activity;
